export enum UserRoleTypes {
  ADMIN = 'ROLE_ADMIN',
  ACCOUNTANT = 'ROLE_ACCOUNTANT',
  USER = 'ROLE_USER',
}
